const SET_EXAM_TIME_REMAINING = "[time-data]set.exam.time.remaining";
const SET_READING_TIME_REMAINING = "[time-data]set.reading.time.remaining";
const INCREMENT_EXAM_ELAPSED_TIME = "[time-data]increment.elapsed.time";
const SET_EXAM_ELAPSED_TIME = "[time-data]set.elapsed.time";
const INCREMENT_EXAM_TIME = "[time-data]increment.exam.time";

export {
    SET_EXAM_TIME_REMAINING,
    SET_READING_TIME_REMAINING,
    INCREMENT_EXAM_ELAPSED_TIME,
    SET_EXAM_ELAPSED_TIME,
    INCREMENT_EXAM_TIME,
};
